export default "__VITE_ASSET__DyXXY7WC__"